import { render, staticRenderFns } from "./edit-pencil.vue?vue&type=template&id=ea6803a0&"
import script from "./edit-pencil.vue?vue&type=script&lang=js&"
export * from "./edit-pencil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea6803a0')) {
      api.createRecord('ea6803a0', component.options)
    } else {
      api.reload('ea6803a0', component.options)
    }
    module.hot.accept("./edit-pencil.vue?vue&type=template&id=ea6803a0&", function () {
      api.rerender('ea6803a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/edit-pencil.vue"
export default component.exports